import React from 'react'
import './styles.css';
import NavBar from './NavBar';

const PrivacyPolicy = () => {
  return (
    <>
      {NavBar()}
      <div className="faq-wrapper">
        <h1 className="faq-title">Privacy Policy</h1>
        <div className="privacy-policy-text" style={{ whiteSpace: 'pre-wrap' }}>
{`
Effective Date: July 17, 2025

Pool Party ("we", "us", or "our") is a mobile social app owned and operated by Console.log LLC. This Privacy Policy describes how we collect, use, and protect your information when you use the Pool Party app and related services (the “Service”).

By using Pool Party, you agree to the collection and use of information in accordance with this policy.

1. INFORMATION WE COLLECT
--------------------------

We collect the following categories of data:

**1.1. Information You Provide**
- Name, email address, location, and profile details
- Video, photo, and media content shared or captured within the app
- Preferences and filters
- Payment details (processed securely through third-party platforms)

**1.2. Automatically Collected Information**
- Device and usage data (IP address, device model, OS, crash logs)
- Geolocation data (if location permissions are enabled)
- Log data (timestamps, interactions, call durations)

**1.3. Information from Third Parties**
- Authentication details from Apple, Google, or Facebook login
- Analytics tools (e.g., Firebase, Mixpanel)
- Payment processors and subscription providers

2. HOW WE USE YOUR INFORMATION
-------------------------------

We use the information we collect to:
- Provide and personalize the Service
- Facilitate real-time video connections
- Operate core features such as Pool browsing, Splashes, Connects, Matches, and messaging
- Process payments and manage subscriptions
- Monitor app performance, security, and fraud prevention
- Communicate with you (including promotional emails, if opted-in)

3. SHARING OF INFORMATION
--------------------------

We may share your information:
- With other users when required to deliver app functionality (e.g. during video calls)
- With service providers (e.g., analytics, cloud storage, video communication tools)
- With law enforcement, if required by applicable law or legal process
- As part of a business transaction (e.g., merger, acquisition)

We do **not** sell your personal information to third parties.

4. DATA SECURITY
-----------------

We implement industry-standard security measures to protect your data, including encryption, access controls, and secure storage. However, no method of transmission over the internet is 100% secure.

5. DATA RETENTION
------------------

We retain your data for as long as your account is active or as needed to provide services, comply with legal obligations, or enforce our agreements.

6. YOUR RIGHTS & CHOICES
-------------------------

You have the right to:
- Access or correct your personal information
- Delete your account and associated data
- Opt out of marketing communications
- Withdraw permissions (e.g., camera, location)

To exercise these rights, email us at **consolelog@consolelogllc.com**.

7. CHILDREN’S PRIVACY
-----------------------

Pool Party is not intended for individuals under the age of 18. We do not knowingly collect personal information from children. If you believe we have done so, please contact us immediately.

8. INTERNATIONAL USERS
-----------------------

Our services are intended for users within the United States. If you access Pool Party from outside the U.S., you consent to the transfer and processing of your information in the U.S.

9. CHANGES TO THIS POLICY
--------------------------

We may update this Privacy Policy occasionally. If we make material changes, we will notify you through the app or via email. Continued use of the Service after such changes constitutes acceptance.

10. CONTACT US
---------------

If you have questions or concerns, contact us at:

**Console.log LLC**  
Email: consolelog@consolelogllc.com  
`}
        </div>
      </div>
    </>
  )
}

export default PrivacyPolicy;
